module.exports = __webpack_public_path__ + "6dbd66122a0f83f068b51705aaec0d96.pdf";